"use client";

import { cn } from "@/lib/utils";
import Image from "next/image";

interface MobileProspectCardProps {
  data: {
    id: string;
    icon?: string;
    alt_icon?: string;
    text: string;
    description?: string;
    title_text_color?: string;
    description_text_color?: string;
    mobile_card_color?: string;
    unselected_text_background_color?: string;
    opacity?: number;
  };
  variant?: "large" | "medium" | "small";
}

const variantStyles = {
  large: {
    container:
      "w-[238px] h-[160px] rounded-2xl shadow-[0px_4px_4px_0px_rgba(44,126,175,0.63)] p-5",
    bgColor: "#0A3D5B",
    iconSize: "w-9 h-9",
    textSize: "text-[18px]",
  },
  medium: {
    container: "w-[202px] h-[116px] rounded-2xl p-4",
    bgColor: "#8FABBF",
    iconSize: "w-9 h-9",
    textSize: "text-[18px]",
  },
  small: {
    container: "w-[168px] h-[94px] rounded-2xl p-3.5",
    bgColor: "#BCD0E0",
    iconSize: "w-9 h-9",
    textSize: "text-[18px]",
  },
};

function MobileProspectCard({
  data,
  variant = "large",
}: MobileProspectCardProps) {
  const {
    icon,
    alt_icon,
    text,
    mobile_card_color,
    title_text_color,

    opacity,
  } = data || {};

  const styles = variantStyles[variant];

  // For large (selected) card: use mobile_card_color or default bgColor
  // For medium/small (unselected) cards: use unselected_text_background_color or default bgColor
  const backgroundColor = mobile_card_color || styles.bgColor;

  return (
    <div
      className={cn(
        "flex items-center justify-start overflow-hidden",
        styles.container
      )}
      style={{ backgroundColor, opacity }}
    >
      <div className="flex items-center gap-2 w-full">
        {icon && icon !== "" && (
          <div className={cn("relative flex-shrink-0", styles.iconSize)}>
            <Image
              src={icon}
              alt={alt_icon || "Program prospect"}
              fill
              className="object-contain"
            />
          </div>
        )}

        <p
          className={cn(
            styles.textSize,
            "font-semibold text-start line-clamp-4 flex-1"
          )}
          style={{ color: title_text_color }}
        >
          {text}
        </p>
      </div>
    </div>
  );
}

export default MobileProspectCard;
